import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { Patient as PatientType, PatientListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const PATIENT_FIELDS = `birthDate cellPhone createdDate email firstName firstVisit gender guarantorFirstName guarantorId guarantorLastName homePhone id insuranceProvider lastName lastVisit locationId patientReferral preferredName referralType status subscriberId updatedDate version workPhone`

const LIST_QUERY = graphql(`
  query Patients($search: String, $pagination: PaginationInput, $sort: SortInput) {
    patients(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        birthDate
        cellPhone
        createdDate
        email
        firstName
        firstVisit
        gender
        guarantorFirstName
        guarantorId
        guarantorLastName
        homePhone
        id
        insuranceProvider
        lastName
        lastVisit
        locationId
        patientReferral
        preferredName
        referralType
        status
        subscriberId
        updatedDate
        version
        workPhone
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query Patient($id: ID!) {
    patient(id: $id) {
      birthDate
      cellPhone
      createdDate
      email
      firstName
      firstVisit
      gender
      guarantorFirstName
      guarantorId
      guarantorLastName
      homePhone
      id
      insuranceProvider
      lastName
      lastVisit
      locationId
      patientReferral
      preferredName
      referralType
      status
      subscriberId
      updatedDate
      version
      workPhone
    }
  }
`)

export class PatientStore extends EntityStore<PatientType, PatientListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      extractList: (data: any) => data.patients,
      extractOne: (data: any) => data.patient,
    })
  }
}
